/**
 * @generated SignedSource<<6ccf24d0c4ca7fec42a8c17e11e133e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeOffSummaryAddRow_account$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AddTimeOffModal_account">;
  readonly " $fragmentType": "TimeOffSummaryAddRow_account";
};
export type TimeOffSummaryAddRow_account$key = {
  readonly " $data"?: TimeOffSummaryAddRow_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeOffSummaryAddRow_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeOffSummaryAddRow_account",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddTimeOffModal_account"
    }
  ],
  "type": "accounts",
  "abstractKey": null
};

(node as any).hash = "2d566b8af8d712745b0bf19a6fb56040";

export default node;
